const skills = {
  technical: [
    {
      name: "Programming",
      level: 95
    }, 
    {
      name: "Database Management",
      level: 90
    }, 
    {
      name: "Security",
      level: 80
    }, 
    {
      name: "Web Development",
      level: 88
    }, 
    {
      name: "Android Development",
      level: 75
    }, 
    {
      name: "Software Development",
      level: 95
    }
  ],
  languages: ["Python", "PHP", "Java", "HTML/CSS", "SQL", "C#"],
  frameworks: ["React", "Node.js", "Laravel", "Ionic", "PiPy"],
  tools: ["Git", "Docker", "Google Scripts", "Linux"]
};

export default skills;